<template>
  <div class="section group fullWidth">
    <div class="col span_1_of_2">
      <router-link :to="'/' + 'units/' + $i18n.locale">
        <div class="close mobileOnly"></div>
      </router-link>
      <div class="unitProductInfo">
        <div class="unitProductInfoBox">
          <p>
            {{ $tc('unit', 1) }} : <span>{{ unitProduct.unit_name }}</span>
          </p>
          <p>
            {{ $t('productName') }} :
            <span>{{ unitProduct.product_name }}</span>
          </p>
          <p>
            {{ $t('productCat') }} : <span>{{ unitProduct.prodCat_name }}</span>
          </p>
        </div>
      </div>
      <br />
      <div class="unitProductDetails">
        <div>
          <span>{{ $t('unitComments') }} </span>
          <div>
            <!-- <quick-edit 
              type="textarea"
              maxlength=220  
              :emptyText="$t('empty')"
              :placeholderValue="$t('productName')" 
              :buttonOkText="'✔'"
              input
              @input="changeUnitProductDetails('comments')"
              :buttonCancelText="'X'"
              :classes="vueQuickEditClassesTextArea" 
              v-model="unitProduct.comments">
            </quick-edit> -->
            <br />
            <textarea
              v-show="!showField('comments')"
              class="field-value active"
              :placeholder="$t('productName')"
              v-model="unitProduct.comments"
              @click="focusField('comments')"
            >
            </textarea>
            <textarea
              v-show="showField('comments')"
              class="field-value form-control inactive"
              v-model="unitProduct.comments"
              maxlength="200"
              @focus="focusField('comments')"
              @blur="
                $v.unitProduct.comments.$touch()
                blurField('comments')
              "
            >
            </textarea>
            <template v-if="$v.unitProduct.comments.$invalid">
              <div
                v-if="!$v.unitProduct.comments.maxLength"
                class="errorMessage"
              >
                {{ $t('unitProdDescLength') }}
              </div>
            </template>
          </div>
          <br />
          <div>
            <div>
              <span>{{ $t('currentStock') }} </span>
              <b-button
                class="questionMark"
                v-b-tooltip.hover
                :title="$t('currentStock?')"
                >?</b-button
              >
              <!-- <quick-edit 
                type="number"
                maxlength=3 
                :emptyText="$t('currentStockReq')"
                :placeholderValue="$t('prodDesc')" 
                :buttonOkText="'✔'"
                input
                @input="changeUnitProductDetails('stock_curr')"
                :buttonCancelText="'X'"
                :classes="vueQuickEditClassesShortInput" 
                v-model="unitProduct.stock_curr">
              </quick-edit> -->
              <br />
              <span
                class="field-value active"
                v-show="!showField('stock_curr')"
                @click="focusField('stock_curr')"
                >{{ unitProduct.stock_curr }}</span
              >
              <input
                v-show="showField('stock_curr')"
                class="field-value form-control inactive"
                v-model="unitProduct.stock_curr"
                type="number"
                maxlength="3"
                @focus="focusField('stock_curr')"
                @blur="
                  $v.unitProduct.stock_curr.$touch()
                  blurField('stock_curr')
                "
              />

              <template v-if="$v.unitProduct.stock_curr.$error">
                <div
                  v-if="!$v.unitProduct.stock_curr.required"
                  class="errorMessage"
                >
                  {{ $t('currentStockReq') }}
                </div>
              </template>
              <template v-if="!$v.unitProduct.stock_curr.$error && this.errors">
                <p v-if="this.errors" class="errorMessage2">
                  {{ this.errors }}
                </p>
              </template>
            </div>
          </div>
          <div>
            <div>
              <span>{{ $t('maxStock') }} </span>
              <b-button
                class="questionMark"
                v-b-tooltip.hover
                :title="$t('maxStock?')"
                >?</b-button
              >
              <br />
              <span
                class="field-value active"
                v-show="!showField('stock_max')"
                @click="focusField('stock_max')"
                >{{ unitProduct.stock_max }}</span
              >
              <input
                v-show="showField('stock_max')"
                class="field-value form-control inactive"
                v-model="unitProduct.stock_max"
                type="number"
                @focus="focusField('stock_max')"
                @blur="
                  $v.unitProduct.stock_max.$touch()
                  blurField('stock_max')
                "
              />
              <template v-if="$v.unitProduct.stock_max.$error">
                <div
                  v-if="!$v.unitProduct.stock_max.required"
                  class="errorMessage"
                >
                  {{ $t('maxStockReq') }}
                </div>
              </template>
              <template v-if="!$v.unitProduct.stock_max.$error && this.errors">
                <p v-if="this.errors" class="errorMessage2">
                  {{ this.errors }}
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>
      <p class="editInstructions">{{ $t('editInstructions') }}</p>
      <br />
      <div class="trash-btn" @click="openQRCodeModal">
        <div>
          <font-awesome-icon class="icon" icon="qrcode" />
          <span> {{ $t('getQRcode') }}</span>
        </div>
      </div>
      <br />
      <router-link
        target="_blank"
        :to="{
          name: 'unitStore',
          params: {
            unitUUID: unitProduct.unit_uuid,
            productUUID: unitProduct.product_uuid
          }
        }"
      >
        <div class="trash-btn hideDesktop">
          <div>
            <font-awesome-icon class="icon" icon="shopping-basket" />
            <span> {{ $t('visitShop') }}</span>
          </div>
        </div>
      </router-link>
      <br />
      <div class="delete-btn" @click="deleteUnitProduct">
        <div style="text-align: left; margin-left: 10px;">
          <font-awesome-icon class="icon" icon="trash" />
          <span> {{ $t('removeUnitProduct') }}</span>
        </div>
      </div>
      <!-- <button :disabled="$v.$invalid" class="save-btn" v-if="isEditing" @click="changeUnitProductDetails">
        <font-awesome-icon class="icon" icon="save" />
        <span> {{ $t('save') }} </span>
      </button>
      <hr />
      <br/>
      <div class="trash-btn" @click="isEditing = !isEditing; isActive = !isActive">
        <div>
          <font-awesome-icon class="icon" icon="edit" />
          <span> {{ $t('changeDetails') }} </span>        
        </div>
      </div> -->
    </div>
    <div class="col span_1_of_2">
      <router-link :to="'/' + 'units/' + $i18n.locale">
        <div class="close desktopOnly"></div>
      </router-link>
      <figure class="about-img3">
        <img
          class="uploadExample"
          src="../assets/static/images/uploadExamples/unitProductImage_example.jpg"
        />
      </figure>
      <UnitProductImageUpload
        :unitId="unitId"
        :productId="productId"
        :imageUrl="unitProduct.img_path"
      ></UnitProductImageUpload>
      <router-link :to="'/' + 'products/' + $i18n.locale">
        <div class="delete-btn">
          <font-awesome-icon class="icon" icon="chevron-left" /><span>
            {{ $t('backToCatalogue') }}</span
          >
        </div>
      </router-link>
    </div>

    <ConfirmDialog
      :visible="showConfirmation"
      class="customClass"
    ></ConfirmDialog>

    <div class="col span_1_of_2">
      <b-modal id="QRcode-modal" size="lg" hide-footer>
        <template v-slot:modal-title>
          <div class="exparLogo">
            <!-- {{ baseUrl }}/unitStore/{{ unitProduct.unit_uuid }}/product/{{ unitProduct.product_uuid}} -->
            <span class="left_area">
              <img
                src="../../src/assets/static/icons/expar_logo_new2.svg"
                alt="expar_logo"
              />
              <span class="logo-text">
                expar
              </span>
            </span>
          </div>
        </template>
        <br />
        <br />
        <div>
          <div id="qrcode" ref="qrcode"></div>
          <br />
          <div class="qr-details">
            <p>
              {{ $tc('unit', 1) }}: <strong>{{ unitProduct.unit_name }}</strong>
            </p>
            <p>
              {{ $t('productName') }}:
              <strong>{{ unitProduct.product_name }}</strong>
            </p>
            <p>
              {{ $t('productCat') }}:
              <strong>{{ unitProduct.prodCat_name }}</strong>
            </p>
          </div>
          <div class="trash-btn" @click="openSelectBoxForQRCodeLayoutModal">
            <span>{{ $t('generatePDF') }}</span>
          </div>
          <br />
        </div>
      </b-modal>
    </div>
    <b-modal id="SelectBoxForQRCodeLayout-modal" size="lg" hide-footer>
      <template v-slot:modal-title>
        <SelectBoxForQRCodeLayout 
          type="UNIT_PRODUCT"
          :unitId="unitId"
          :productId="productId"
          @close-modal="closeSelectBoxForQRCodeLayout"
        />
      </template>
    </b-modal>
  </div>
</template>

<script>
import * as QRCode from 'easyqrcodejs'
import ConfirmDialog from 'primevue/confirmdialog'
import UnitProductImageUpload from '../components/ui/UnitProductImageUpload.vue'
import SelectBoxForQRCodeLayout from '../components/forms/SelectBoxForQRCodeLayout.vue'
import { jsPDF } from 'jspdf'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  metaInfo() {
    return {
      title: this.title
    }
  },
  components: {
    UnitProductImageUpload,
    ConfirmDialog,
    SelectBoxForQRCodeLayout
  },
  data() {
    return {
      title: 'Unit Product',
      url: `${process.env.VUE_APP_BASE_URL}/unitStore/${this.unitProduct.unit_uuid}/product/${this.unitProduct.product_uuid}`,
      size: 100,
      unitId: this.$route.params.unitId,
      productId: this.$route.params.productId,
      isEditing: false,
      isActive: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      errors: null,
      showConfirmation: false,
      vueQuickEditClassesShortInput: {
        wrapper: 'form-group form-inline',
        input: 'formControl short input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      vueQuickEditClassesTextArea: {
        wrapper: 'form-group form-inline textBoxArea',
        input: 'formControl addInfoArea input-sm',
        buttons: 'btn-group btn-group-sm',
        buttonOk: 'btn saveBtn',
        buttonCancel: 'btn closeBtn'
      },
      editField: ''
    }
  },
  mounted() {
    this.title = this.unitProduct.product_name
  },
  validations: {
    unitProduct: {
      comments: { maxLength: maxLength(200) },
      stock_curr: { required },
      stock_max: { required }
    }
  },
  methods: {
    focusField(name) {
      if (name === 'stock_curr' && this.$v.unitProduct.stock_curr.$error) {
        this.errors = null
      }
      this.editField = name
    },
    blurField(name) {
      this.editField = ''
      this.changeUnitProductDetails(name)
    },
    showField(name) {
      return this.unitProduct[name] == '' || this.editField == name
    },
    // deleteUnitProduct() {
    //   if (confirm('are you sure?')) {
    //     this.$store
    //       .dispatch('unitProduct/removeUnitProduct', {
    //         unitId: this.unitId,
    //         productId: this.productId})
    //       .then(() => {
    //         this.$router.push({
    //           path: `/unit/${this.unitId}`
    //         })
    //       })
    //   }
    // },
    deleteUnitProduct() {
      this.$confirm.require({
        message: this.$t('confirmUnitProductDelete'),
        header: this.$t('areYouSure'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.$store
            .dispatch('unitProduct/removeUnitProduct', {
              unitId: this.unitId,
              productId: this.productId
            })
            .then(() => {
              this.$router.push({
                path: `/unit/${this.unitId}`
              })
            })
        },
        reject: () => {
          this.showConfirmation = false
        }
      })
    },
    changeUnitProductDetails(propertyName) {
      if (this.unitProduct[propertyName] === '') {
        return
      }
      // if (
      //   confirm('are you sure? This will rewrite excisting unit product details')
      // )
      {
        this.$store
          .dispatch('unitProduct/editUnitProduct', this.unitProduct)
          .then(() => {
            this.errors = null
            this.isEditing = !this.isEditing
            this.isActive = !this.isActive
          })
          .catch(err => {
            if (err.response.data === 'stock_unavailable') {
              this.errors = this.$t('noProductStock')
              this.focusField('stock_curr')
            } else this.errors = err.response.data
          })
      }
    },
    async downloadQRCodePdf() {
      const qrcode = document.getElementById('qrcode')
      let qrCanvas = qrcode.firstChild

      const imgData = qrCanvas.toDataURL('image/png')
      const doc = new jsPDF('p', 'mm', 'a4')

      doc.addImage(imgData, 'PNG', 20, 30, 60, 60)

      const dataUri = await this.convertTextToImage()
      doc.addImage(dataUri, 'PNG', 20, 100)

      doc.save(`QR-Code:${this.unitId}-${this.productId}.pdf`)
    },
    convertTextToImage() {
      return new Promise((resolve, reject) => {
        const textToConvert = `Unit : ${this.unitProduct.unit_name}\nProduct Name : ${this.unitProduct.product_name}\nProduct category : ${this.unitProduct.prodCat_name}`
        this.$store
          .dispatch('unitProduct/convertTextToImage', {
            text: textToConvert
          })
          .then(response => {
            return resolve(response.dataUri)
          })
          .catch(error => {
            return reject(error)
          })
      })
    },
    getBase64Image(img) {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      const dataURL = canvas.toDataURL('image/png')
      return dataURL
    },
    renderQRCode() {
      let options = {
        text: this.url,
        width: 200,
        height: 200,
        logo: '../../../expar_logo_new.svg',
        dotScale: 0.5,
        PO: '#0c2e44',
        PI: '#fb7377'
      }

      new QRCode(this.$refs.qrcode, options)
    },
    async openQRCodeModal() {
      await this.$bvModal.show('QRcode-modal')
      this.renderQRCode()
    },
    openSelectBoxForQRCodeLayoutModal() {
      this.$bvModal.show('SelectBoxForQRCodeLayout-modal')
    },
    closeSelectBoxForQRCodeLayout() {
      this.$bvModal.hide('SelectBoxForQRCodeLayout-modal')
    }
  },
  template: '<qrcode-vue :value="url"></qrcode-vue>',
  props: {
    unitProduct: {
      type: Object,
      default: () => {
        return {}
      }
    },
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style scoped>
.fullWidth {
  width: 100%;
}
.unitProductDetails {
  border: solid 1px var(--bg);
  padding: 30px;
  text-align: left;
}
.unitProductDetails span {
  color: var(--grey);
}

textarea {
  height: auto;
}

.close {
  position: absolute;
  width: 25px;
  height: 25px;
  opacity: 0.3;
  padding: 10px;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}

/*  SECTIONS  */
.section {
  clear: both;
  padding: 0px;
  margin: 0px;
}

/*  COLUMN SETUP  */
.col {
  display: block;
  float: left;
  margin: 1% 0 1% 2%;
}
.col:first-child {
  margin-left: 0;
}

/*  GROUPING  */
.group:before,
.group:after {
  content: '';
  display: table;
}
.group:after {
  clear: both;
}
.group {
  zoom: 1; /* For IE 6/7 */
}

/*  GRID OF TWO  */
.span_2_of_2 {
  width: 100%;
}
.span_1_of_2 {
  width: 49%;
}

.inactive {
  background-color: var(--primarySuperLight);
  border-radius: 3.5px;
  font-style: italic;
}

.productName {
  text-align: left;
  padding-left: 50px;
  font-size: 3em;
  width: 100%;
}
.unitProductDetails {
  margin-left: 10px;
  padding: 20px;
}

.exparLogo {
  text-align: left;
  margin-bottom: -15px;
}
.left_area img {
  width: 10%;
  padding: 5px;
  margin-bottom: 10px;
}
.left_area span {
  font-family: 'Nasalization', Helvetica, Arial;
  color: var(--bg);
  font-size: 2rem;
  letter-spacing: 0px;
  font-weight: 500;
  margin-left: -6px;
}

.questionMark {
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  background-color: var(--bg-light) !important;
  padding: 2px 10px !important;
  margin-left: 5px !important;
  margin-right: 3px !important;
  z-index: 1;
}

.questionMark:hover {
  background-color: var(--primaryDark) !important;
}

.editInstructions {
  color: var(--grey);
  font-size: 0.8em;
}

.unitProductInfo {
  padding: 0 5px;
  display: flex;
  justify-content: center;
}
.unitProductInfoBox {
  border-radius: 10px;
  max-width: 550px;
  text-align: left;
  font-size: 1.3em;
  background-color: var(--grey-light);
}

.unitProductInfo span {
  font-weight: 600;
}

.unitProductInfoBox p {
  margin-bottom: 16px;
  padding: 5px 20px;
}

.trash-btn {
  background-color: var(--bg-light);
  cursor: pointer;
  color: var(--bright);
  padding: 5px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 3.5px;
  margin: auto;
  width: 15em;
  height: 32px;
  text-decoration: none;
}

.trash-btn:active {
  text-decoration: none;
}

.trash-btn div {
  text-align: left;
  margin-left: 10px;
}

.delete-btn {
  background-color: var(--primaryDark);
  cursor: pointer;
  color: var(--bright);
  padding: 5px;
  letter-spacing: 3px;
  border: none !important;
  border-radius: 3.5px;
  margin: auto;
  width: 15em;
  height: 32px;
  text-decoration: none;
}

.delete-btn:active {
  text-decoration: none !important;
}

.delete-btn:hover {
  text-decoration: none !important;
}

.qr-details {
  text-align: left;
}

.uploadDetails {
  font-size: 1.5em;
}

.about-img3 {
  display: inline-block;
  width: 100%;
  max-width: 400px;
  text-align: center;
  vertical-align: top;
}
.uploadExample {
  max-width: 300px;
  width: 100%;
}

.edit-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.5em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 300px;
  height: 40px;
  text-align: left;
}

.save-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 0.4em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  height: 38px;
  text-align: center;
  width: 120px;
}

.errorMessage {
  margin-top: -15px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
  z-index: -1;
  text-align: left;
}

.errorMessage2 {
  margin-top: 0px;
  margin-bottom: 0.2em;
  padding-left: 5px;
  padding-top: 4px;
  color: var(--primaryDark);
  font-size: 0.58em;
  z-index: -1;
  text-align: left;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

textarea {
  padding: 10px;
  width: 100%;
  height: 250px;
}

::-webkit-input-placeholder {
  color: #ff6961;
}
:-moz-placeholder {
  color: #ff6961;
}
::-moz-placeholder {
  color: #ff6961;
}
:-ms-input-placeholder {
  color: #ff6961;
}

@media screen and (min-width: 561px) {
  .hideDesktop {
    display: none;
  }
  .delete-btn:hover {
    text-decoration: none;
  }
  .trash-btn:hover {
    text-decoration: none;
  }
  .mobileOnly {
    display: none;
  }
  .desktopOnly {
    display: inline;
    right: 20px;
    top: 5px;
  }
}

@media screen and (max-width: 560px) {
  textarea {
    width: 100%;
    height: 250px;
  }
  .uploadDetails {
    font-size: 1.2em;
  }
  .unitProductInfoBox {
    font-size: 1.1em;
    margin-top: 5px;
    padding: 20px 10px;
  }
  .trash-btn {
    width: auto;
    margin: 0 30px;
  }
  .delete-btn {
    width: auto;
    margin: 0 30px;
  }
  .unitProductDetails {
    text-align: left;
  }
  .left_area img {
    width: 20%;
    margin-bottom: 10px;
  }
  .mobileOnly {
    display: inline;
    right: 30px;
    top: 0px;
  }
  .desktopOnly {
    display: none;
  }
}

@media screen and (max-width: 415px) {
  textarea {
    height: 100px;
  }
  .productName {
    font-size: 2em;
    font-weight: 600;
    text-align: left;
    padding-left: 0;
  }
  .product-page div {
    text-align: left;
    margin-left: 20px;
  }
}

.icon {
  font-size: 1.3em;
  padding: 1px;
  text-align: left;
}
.active {
  border-radius: 3.5px;
  background: none !important;
  font-weight: 600;
  font-style: normal !important;
  width: 100%;
}
.inactive {
  background-color: var(--primarySuperLight);
  border-radius: 3.5px;
  font-style: italic;
  margin: auto;
  width: 100%;
  height: auto;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}

@media only screen and (max-width: 480px) {
  .span_1_of_2 {
    width: 100%;
    padding: 0;
  }
  .span_2_of_2 {
    width: 100%;
  }
  .col {
    margin: 1% 0 1% 0%;
  }
}

@media only screen and (min-width: 480px) {
  .mobileOnly {
    display: none;
  }
}

@media screen and (orientation: landscape) and (min-device-width: 319px) and (max-device-width: 680px) {
  .span_1_of_2 {
    width: 100% !important;
  }
  .unitProductInfoBox {
    margin-right: 35px;
  }
}
</style>
